<template>
  <div class="lk-menu" :class="{ close: close }">
    <ul class="menu-items">
      <li
        v-for="(link, link_index) in links"
        :key="`menu-link-${link_index}`"
        class="menu-item"
        :class="{ loading: link.loading, 'border-bottom': link.show }"
        @click="itemClick(link, link_index)"
        so
      >
        <div v-if="link.show">
          <h3 class="main-item main">
            {{ link.title }}
          </h3>
          <div
            class="menu-items-sub-menu-collapse"
            v-if="selected_main_item === link_index && link.sub_menu.length > 1"
          >
            <ul class="menu-items-sub-menu">
              <li
                class="menu-item-sub-menu"
                :class="{ selected: sub_link.selected }"
                v-for="(sub_link, sub_link_index) in link.sub_menu"
                :key="`sub-link-index-${sub_link_index}`"
                @click="subItemClick(sub_link)"
              >
                <h4
                  class="main-item"
                  v-if="sub_link.text"
                  v-html="sub_link.text"
                ></h4>
              </li>
            </ul>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ArrowRight from "../../assets/images/angle-right-solid.svg";
export default {
  props: {
    close: {
      default: true,
      type: Boolean
    }
  },
  data() {
    return {
      selected_main_item: -1,
      icons: {
        arrow_right: ArrowRight
      }
    };
  },
  methods: {
    changeLang(locale) {
      this.$i18n.locale = locale;
    },
    userLogout() {
      this.$store.dispatch("userLogout").finally(() => {});
      // auth.checkUserAuthorization(this.$router, this.$store);
    },
    changePortfolio(portfolioId) {
      if (this.selectedPortfolio == portfolioId) {
        return;
      }
      this.$store.dispatch("changeSelectedPortfolio", {
        portfolioId: portfolioId,
        route_name: this.$route.name
      });
    },
    changeSelectedBroker(value) {
      this.$toasted.show("Загрузка...");
      this.$store.dispatch("changeSelectedClient", value).then(res => {
        if (res.data.status) {
          window.location.reload();
        } else {
          this.$toasted.show("Произошла ошибка при смене клиента");
        }
      });
    },
    itemClick(item, index) {
      item.click();
      this.selected_main_item = this.selected_main_item == index ? -1 : index;
    },
    subItemClick(item) {
      item.click(item.value);
    }
  },
  computed: {
    onLoading() {
      let operations =
        this.getPortfolioLoading ||
        this.isIncomeLoading ||
        this.getMoneyDataLoading;
      return operations;
    },
    ...mapGetters([
      "portfoliosList",
      "getClientList",
      "getUserProfile",
      "getPortfolioLoading",
      "getMoneyDataLoading",
      "selectedPortfolio",
      "isIncomeLoading",
      "isUserVIP"
    ]),
    clientId() {
      return this.getUserProfile
        ? this.getUserProfile.user
          ? this.getUserProfile.user.clientId
          : null
        : null;
    },
    portfolios() {
      const list = this.portfoliosList;
      // console.log(list);
      let result = list.map(item => {
        if (!item.selected) item.selected = false;
        item.click = value => this.changePortfolio(value);
        return item;
      });
      return result;
    },
    clients() {
      const list = this.getClientList;
      // console.log(list, this.clientId);
      // return [];
      return list.map(item => {
        item.click = value => this.changeSelectedBroker(value);
        if (this.clientId == item.value) {
          item.selected = true;
        } else {
          item.selected = false;
        }
        return item;
      });
    },
    links() {
      return [
        {
          title: "Профиль",
          click: () => this.$router.push("/profile/docs"),
          sub_menu: [],
          show: true
        },
        {
          title: `Язык : ${this.$i18n.locale.toUpperCase()}`,
          click: () => {},
          show: true,
          sub_menu: [
            {
              value: "ru",
              text: "Рус",
              selected: this.$i18n.locale == "ru",
              click: lang => this.changeLang(lang)
            },
            {
              value: "kz",
              text: "Қаз",
              selected: this.$i18n.locale == "kz",
              click: lang => this.changeLang(lang)
            },
            {
              value: "en",
              text: "Eng",
              selected: this.$i18n.locale == "en",
              click: lang => this.changeLang(lang)
            }
          ]
        },
        {
          title: this.getPortfolioLoading
            ? "Загрузка данных..."
            : `Клиент : ${
                (
                  this.clients.filter(item => item.selected)[0] || {
                    text: "Не выбран"
                  }
                ).text
              }`,
          show: this.clients.length > 1,
          sub_menu: !this.getPortfolioLoading ? [...this.clients] : null,
          click: () => {},
          loading: this.getPortfolioLoading
        },
        {
          title: this.getPortfolioLoading
            ? "Загрузка данных..."
            : `Портфель : ${
                (
                  this.portfolios.filter(item => item.selected)[0] || {
                    text: "Не выбран"
                  }
                ).text
              }`,
          sub_menu: !this.getPortfolioLoading ? [...this.portfolios] : null,
          show: this.portfolios.length > 2,
          click: () => {},
          loading: this.getPortfolioLoading
        },
        {
          title: "Выйти",
          sub_menu: [],
          show: true,
          click: () => this.userLogout()
        }
      ];
    }
  },
  beforeMount() {
    this.$store.dispatch("fetchClientInfo");
    this.$store.dispatch("fetchClientOptionList");
  }
};
</script>
<style>
.lk-menu {
  color: #222d44;
  top: 110px;
  right: 15px;
  width: 300px;
  position: absolute;
  background-color: white;
  box-shadow: 0px 10px 60px rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  border-radius: 5px;
  z-index: 10;
  pointer-events: auto;
  transition: all 0.2s;
}
.lk-menu.close {
  pointer-events: none;
  opacity: 0;
  transform: translateY(30px);
}
.lk-menu .menu-items,
.menu-items-sub-menu {
  font-size: 14px;
  list-style: none;
  padding-left: 0px;
}
.lk-menu .menu-items li {
  cursor: pointer;
  transition: all 0.1s;
}
.lk-menu .menu-items li.border-bottom {
  border-bottom: 2px solid rgba(0, 0, 0, 0.09);
}
.lk-menu .menu-items li.loading {
  background-color: rgba(0, 0, 0, 0.1) !important;
}
.menu-items-sub-menu-collapse {
  overflow: hidden;
  height: auto;
  transition: 0.3s;
}
.menu-items-sub-menu-collapse.close {
  height: 0px;
}
.menu-item-sub-menu:hover,
.main-item.main:hover {
  background-color: rgba(0, 0, 0, 0.2);
}
.main-item {
  font-weight: normal;
  padding: 10px 15px;
}

.menu-item-sub-menu {
  padding-left: 30px;
  background-color: rgba(0, 0, 0, 0.1);
}
.menu-item-sub-menu.selected {
  background-color: #1a75e9;
  color: white;
}
.lk-menu .menu-items li:last-child {
  border-bottom: none;
}
</style>
